import Grid from "@material-ui/core/Grid";
import React from "react";
import { Route, useHistory } from "react-router-dom";
import MockHeaderComponent from "./MockHeaderComponent";
import MockIntelligence from "./MockIntelligence";
import MockOrderManager from "./MockOrderManager";
import MockReportGeneratorComponent from "./MockReportGeneratorComponent";
import MockSideBarComponent from "./MockSideBarComponent";
import { mockUiTemplate } from "./mockUiTemplate";
import ProgressBar from "./ProgressBar";
import makeStyles from "@material-ui/core/styles/makeStyles";

const drawerWidth = 240;
const MockShellComponent = () => {
  const history = useHistory();
  const classes = useStyles();

  React.useEffect(() => {
    history.push("/kavida/tour/command-tower");
  }, []);

  const getRoutes = () => {
    if (
      window.location.pathname !== "/kavida/tour/supplier-delays" &&
      window.location.pathname !== "/kavida/tour/commodity-risks" &&
      !window.location.pathname.includes("/supplier")
    )
      return mockUiTemplate.map((prop, key) => {
        if (prop.layout === "/kavida") {
          if (prop.component === "Intelligence")
            return (
              <Route
                path={prop.layout + prop.path}
                component={MockIntelligence}
                key={key}
              />
            );
          if (prop.component === "MilestoneTracker")
            return (
              <Route
                path={prop.layout + prop.path}
                component={MockOrderManager}
                key={key}
              />
            );
          if (prop.component === "ReportGenerator") {
            let path = `${prop.layout}${prop.path}`;

            return (
              <Route
                path={path}
                component={MockReportGeneratorComponent}
                key={key}
              />
            );
          }
        } else {
          return null;
        }
      });
  };

  const getHeaderTitle = () => {
    for (let i = 0; i < mockUiTemplate.length; i++) {
      if (
        window.location.pathname.indexOf(
          mockUiTemplate[i].layout + mockUiTemplate[i].path
        ) !== -1
      ) {
        return mockUiTemplate[i].name;
      }
    }
  };

  return (
    <>
      <div style={{ backgroundColor: "#F7F8FC", backgroundSize: 'cover' }}>
        <MockHeaderComponent title={getHeaderTitle()} />
        <MockSideBarComponent
          routeTemplates={mockUiTemplate}
          selectedMenu={mockUiTemplate[0].name}
        />
        <div className={classes.content}>
          <Route/>
          {getRoutes()}
        </div>
        <Grid container justifyContent='flex-end' style={{paddingRight: '16px', backgroundColor: "#F7F8FC"}}>
            <Grid item >
              <ProgressBar />
            </Grid>
        </Grid>
      </div>
    </>
  );
};

export default MockShellComponent;

const useStyles = makeStyles((theme) => ({
  content: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    marginTop: '65px',
    margin: '0px 16px',
    paddingTop: '16px',
    paddingInline: '16px',
  }
})
);
